import { VueConstructor } from 'vue';

import {
  Button,
  ButtonGroup,
  Pagination,
  Input,
  DatePicker,
  // Radio,
  // RadioGroup,
  Checkbox,
  CheckboxGroup,
  Table,
  TableColumn,
  Select,
  Option,
  Container,
  Header,
  Footer,
  Main,
  Menu,
  MenuItem,
  Submenu,
  Calendar,
  Card,
  Form,
  FormItem,
  Dialog,
  Link,
  Tag,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Divider,
  Loading,
  Message,
} from 'element-ui';
import ShDropdown from '@/components/DropdownMenu.vue';

export default {
  install(Vue: VueConstructor, params: PlainObject) {
    Vue.prototype.$ELEMENT = params;
    // console.log('params', params);
    Vue.use(Loading, params);
    Vue.use(Form, params);
    Vue.use(FormItem, params);
    Vue.use(Dialog, params);
    Vue.use(Link, params);
    Vue.use(Button, params);
    Vue.use(ButtonGroup, params);
    Vue.use(Pagination, params);
    Vue.use(Input, params);
    Vue.use(DatePicker, params);
    // Vue.use(Radio, params);
    // Vue.use(RadioGroup, params);
    Vue.use(Checkbox, params);
    Vue.use(CheckboxGroup, params);
    Vue.use(Table, params);
    Vue.use(TableColumn, params);
    Vue.use(Select, params);
    Vue.use(Option, params);
    Vue.use(Container, params);
    Vue.use(Header, params);
    Vue.use(Footer, params);
    Vue.use(Main, params);
    Vue.use(Menu, params);
    Vue.use(MenuItem, params);
    Vue.use(Submenu, params);
    Vue.use(Calendar, params);
    Vue.use(Card, params);
    Vue.use(Tag, params);
    Vue.use(Dropdown, params);
    Vue.use(DropdownItem, params);
    Vue.use(DropdownMenu, params);
    Vue.use(Divider, params);

    // 重写Dropdown
    // Vue.component(ShDropdown.name, ShDropdown);
        Vue.component('sh-dropdown', ShDropdown);
        // console.log('ShDropdown.name',ShDropdown.name)
    Vue.prototype.$message = Message;
  },
};
